<template>
  <div id="damages" class="vue-rqf-page">
    <template v-if="$root.car.model">
      <h3>Skader</h3>
      <div class="car-make-and-model">
        <img :src="$root.car.brand_logo">
        <div class="car-make-and-model-details">
          <div class="car-make-and-model-year" v-text="$root.car.year"></div>
          <div class="car-make-and-model-model" v-text="$root.car.producer + ' ' + $root.car.model"></div>
        </div>
      </div>
    </template>
    <div class="damages-wrap">
      <h3>Start med å legge til en skade</h3>
      <p>Marker med et klikk på modellen hvor skaden er og last opp bilder av skaden. Vi ønsker veldig gjerne å gi deg
        ett så nøyaktig prisestimat som mulig, så fint om du gjør følgende:</p>
      <ul>
        <li>Send oss 4 – 6 bilder!
          <br>2 detalj- og 2 oversiktsbilder fra forskjellige vinkler
        </li>
        <li>Fint om bilen er ren</li>
        <li>Pass på at bildene er i fokus</li>
        <li>Ta gjerne bilder i godt lys som naturlig dagslys</li>
      </ul>
      <p>Se eksempel på <a href="#" @click.stop.prevent="$root.showUILightbox()">hvilke type bilder du kan ta</a>.
      </p>
      <div class="damages-form">
        <div class="damage">
          <template v-for="(damage,damageIndex) in $root.damages">
            <div class="damage-item" :class="{active: ((null === damage.active && 0 === damageIndex) || true === damage.active)}">
              <div class="damage-label" v-on:click="$root.toggleDamageContentView(damageIndex)">
                <span class="text" v-if="0 === damageIndex">Front</span>
                <span class="text" v-else-if="1 === damageIndex">Høyre side</span>
                <span class="text" v-else-if="2 === damageIndex">Bakpart</span>
                <span class="text" v-else-if="3 === damageIndex">Venstre side</span>
                <span class="text" v-else-if="4 === damageIndex">Kilometerteller</span>
                <span class="text" v-else-if="5 === damageIndex">Drivstoff</span>
                <span class="text" v-else-if="6 === damageIndex">Tak</span>
                <span class="text" v-else-if="7 === damageIndex">Documents</span>
                <span class="text" v-else>Ekstra bilde</span>
                <span class="icon"></span>
              </div>
              <div class="damages-block">
                <div class="preview-wrap">
                  <ul class="preview">
                    <li v-for="(fileId,index) in damage.images">
                      <img :src="$root.files[fileId].url" :alt="'Skade ' + (index+1)">
                      <span class="remove" @click.prevent="$root.removeImage(index,damageIndex)">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                    </svg>
                  </span>
                    </li>
                  </ul>

                  <label :for="'mps-upload-image-'+damageIndex" class="upload">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="3.2"/>
                      <path
                          d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                    </svg>
                    <image-uploader :id="'mps-upload-image-'+damageIndex"
                                    :debug="2"
                                    :maxWidth="2000"
                                    :maxHeight="2000"
                                    :quality="0.7"
                                    :autoRotate=true
                                    outputFormat="verbose"
                                    :preview=false
                                    :capture="false"
                                    doNotResize="['gif', 'svg']"
                                    @input="$root.addImage($event,damageIndex)"
                                    @onUpload="$root.onStartUploadImage"
                                    @onComplete="$root.onCompleteUploadImage"
                                    accept="image/*"
                    ></image-uploader>
                    <span class="cursor"></span>
                  </label>

                  <span v-if="!damage.images.length && $root.damages.length > 7 && damageIndex > 6" class="remove"
                        @click.prevent="$root.removeDamage(damageIndex)">
                      <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                      </svg>
                  </span>


                </div>



                <div v-if="7 !== damageIndex" class="form-damage-description">
                  <label :for="'description_' + + (damageIndex+1)">Beskrivelse Skade</label>
                  <textarea v-model="$root.request['description_' + + (damageIndex+1)]"
                            :id="'description_' + + (damageIndex+1)" rows="2"></textarea>
                </div>
              </div>

            </div>
          </template>
        </div>
      </div>
      <div class="mps-actions first-screen-actions">
        <button @click.prevent="$root.addDamage" id="js-add-damage" class="button primary">Legg til skade</button>
        <button @click.prevent="$root.submitDamages" class="button secondary" id="gtm-inquiry-continue-damages">
          Fortsett
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import ImageUploader from 'vue-image-upload-resize'

export default {
  data() {
    return {
      //msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    ImageUploader
  },
  methods: {
    resolveRequest: function (data) {

      var self = this;

      if (!data) {
        self.$root.showModal('Not found.');
        return;
      }

      let request = data.request
      request.car_rental_approval = parseInt(request.car_rental_approval) ? 1 : 0;
      request.offer_estimation = parseFloat(request.offer_estimation) ? parseFloat(request.offer_estimation) : 0;

      self.$store.commit('set', {type: 'request', val: request})

      var contact = data.contact
      self.$store.commit('set', {type: 'contact', val: contact})

      console.log(data);

      if(data.car)
        self.$store.commit('set', {type: 'car', val: data.car})

      var damages = data.damages;

      self.$root.files = [];
      for (var i = 0; i < damages.length; i++) {
        var damage = damages[i];
        var files = JSON.parse(damage.images).map(function (item, idx) {
          return {
            url: item
          }
        });

        damage.position = {
          top: damage.position_top,
          left: damage.position_left
        };
        damage.images = files.map(function (item, idx) {
          return parseInt(idx) + self.$root.files.length;
        });
        damage.type = damage.type ? JSON.parse(damage.type) : [];

        delete damage.position_top
        delete damage.position_left

        self.$root.files = self.$root.files.concat(files);
      }
      self.$store.commit('set', {type: 'damages', val: damages})
    },
  },
  created: function () {
    var self = this;
    if (self.$route.name == 'damage-item-bug') {
      self.$root.ui.loading = 'getRequest';

      Promise.all([
        self.$api.getWorkshops(),
        self.$api.getRequest(this.$route.params.code, this.$route.params.type)
      ]).then(function (data) {

        console.log("resolve request");
        console.log(data);

        self.$root.resolveWorkshops(data[0]);
        self.resolveRequest(data[1]);
        if (self.$root.offerFormIsNeeded())
          self.$api.getDamageOfferTexts(self.$root.request.id_workshop).then(function (data) {
            self.$root.damageOfferTexts = data['damageTexts'];
            self.$root.offerTexts = data['offerTexts'];
          });
        self.$root.ui.loading = false;
      });
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Damages.vue?74ea0fc8